import { useTranslation } from "react-i18next"
import { Spacer } from "../../../../components/spacer/Spacer"
import { theme } from "../../../../styles/stitches.config"
import { ValueInput } from "../ValueInput"
import { InputSetContainer } from "./InputSetContainer"
import { LabelWithTooltip } from "./LabelWithTooltip"
import { EnergyUnit } from "@nano-portal/shared"

const annualProducedMWhPerKWp = 1

interface Props {
  installedPowerInKWp?: number
  onChange: (value?: number) => void
}

export const PowerAndProductionInput = ({ installedPowerInKWp, onChange }: Props) => {
  const { t } = useTranslation("microsite")

  const handlePowerChange = (value?: number) => {
    onChange(value !== undefined ? value * annualProducedMWhPerKWp : undefined)
  }

  const handleProductionChange = (value?: number) => {
    onChange(value)
  }

  return (
    <InputSetContainer>
      <ValueInput
        valueLabel="kWp"
        value={installedPowerInKWp}
        onChange={handlePowerChange}
        inputLabel={<LabelWithTooltip label={t("installed_power")} tooltip={t("installed_power_tooltip")} />}
      />

      <Spacer size={theme.space.s6} />

      <ValueInput
        valueLabel={EnergyUnit.MWh}
        value={installedPowerInKWp !== undefined ? installedPowerInKWp * annualProducedMWhPerKWp : installedPowerInKWp}
        onChange={handleProductionChange}
        inputLabel={<LabelWithTooltip label={t("annual_production")} tooltip={t("annual_production_tooltip")} />}
      />
    </InputSetContainer>
  )
}
